import { MarkdownRenderer } from '@/components/ui/MarkdownRenderer';
import type { BlockRendererProps } from '../registry';

export function ContentBlockRenderer({ block }: BlockRendererProps) {
  return <MarkdownRenderer content={block.content} />;
}
